export const Heart = (props) => {
  const { size = 28, onClick, verticalAlign, marginLeft, marginRight, top, color, fill = 'none', className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill={fill} viewBox='0 0 28 28'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='M18.797 3.5c4.11 0 6.87 3.911 6.87 7.56 0 7.39-11.459 13.44-11.666 13.44-.208 0-11.667-6.05-11.667-13.44 0-3.649 2.761-7.56 6.87-7.56 2.36 0 3.902 1.194 4.797 2.244.894-1.05 2.437-2.244 4.796-2.244z'
        ></path>
      </svg>
    </span>
  );
};
